import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Input } from '../ui/input';
import { API_URL, errMsg, clampMeta } from './com360Shared';

export const MetaCell = ({ user, editable }) => {
  const [v, setV] = useState(user.meta_mensal ?? '');
  useEffect(() => setV(user.meta_mensal ?? ''), [user.meta_mensal]);
  if (!['comercial', 'chefe_equipa'].includes(user.role)) return <span className="text-slate-300">—</span>;
  if (!editable) return <span>{user.meta_mensal || '—'}</span>;
  const save = async () => {
    const n = clampMeta(v);
    setV(n);
    if (n === (user.meta_mensal || 0)) return;
    try { await axios.put(`${API_URL}/users/${user.id}/meta`, { meta_mensal: n }); user.meta_mensal = n; toast.success(`Meta de ${user.name}: ${n} contratos/mês`); }
    catch (e) { toast.error(errMsg(e, 'Erro ao guardar meta')); }
  };
  return (
    <Input type="number" min={0} max={1000} value={v} placeholder="0" onChange={(e) => setV(e.target.value)} onBlur={save}
      onKeyDown={(e) => e.key === 'Enter' && e.currentTarget.blur()} className="h-8 w-20" data-testid={`user-meta-input-${user.id}`} />
  );
};
